import api from './api';
import {
  ClubAddress as ShopAddress,
  DartCloudTime,
  OpeningHour,
  ClubTrainingSchedule as WeekSchedule,
  SocialMediaCollection,
  normalizeDetail,
} from './clubService';

export type { ShopAddress, DartCloudTime, OpeningHour, WeekSchedule, SocialMediaCollection };

export interface Shop {
  _id?: string;
  id?: string;
  name?: string;
  slug?: string;
  description?: string | null;
  image?: string | null;
  images?: string[] | null;
  logo?: string | null;

  address?: ShopAddress;

  email?: string | null;
  phone?: string | null;

  openingHours?: WeekSchedule | null;

  shopLink?: string | null;

  localDartTesting?: boolean | null;
  localPointChange?: boolean | null;

  paymentMethods?: string[] | null;

  series?: string[];
  tournaments?: string[];

  socialMediaCollection?: SocialMediaCollection | null;
  tags?: string[] | null;

  owner?: string | null;
  admins?: string[];
  createdBy?: string | null;
  createdAt?: number;
  updatedAt?: number | null;
  validUntil?: number;
  visible?: boolean;
  sponsored?: boolean;
  views?: number;
}

export interface ShopDetailResponse {
  success: boolean;
  data: Shop | null;
}

class ShopService {
  async getShopBySlug(slug: string): Promise<ShopDetailResponse> {
    const res = await api.get(`/api/shop/slug/${encodeURIComponent(slug)}`);
    return normalizeDetail<Shop>(res.data);
  }

  async getShopById(id: string): Promise<ShopDetailResponse> {
    const res = await api.get(`/api/shop/${encodeURIComponent(id)}`);
    return normalizeDetail<Shop>(res.data);
  }

  async createShop(payload: any): Promise<any> {
    const res = await api.post('/api/shop/create', payload);
    return res.data;
  }

  async updateShop(payload: any): Promise<any> {
    const res = await api.post('/api/shop/update', payload);
    return res.data;
  }

  async deleteShop(id: string): Promise<any> {
    const res = await api.post('/api/shop/delete', { id });
    return res.data;
  }

  async addImage(id: string, data: string): Promise<any> {
    const res = await api.post('/api/shops/image/add', { id, data });
    return res.data;
  }

  async removeImage(id: string, image: string): Promise<any> {
    const res = await api.post('/api/shops/image/remove', { id, image });
    return res.data;
  }

  buildFileUrl(fileId?: string | null): string | null {
    if (!fileId) return null;
    if (fileId.startsWith('http://') || fileId.startsWith('https://')) return fileId;
    const base = api.defaults.baseURL || '';
    return `${base}/api/file/${fileId}`;
  }

  formatAddress(address?: ShopAddress | null): string {
    if (!address) return 'Adresse nicht hinterlegt';
    if (address.label && address.label.trim().length > 0) return address.label;
    const parts: string[] = [];
    if (address.street) parts.push(address.street);
    const cityLine = [address.postcode, address.city].filter(Boolean).join(' ');
    if (cityLine) parts.push(cityLine);
    if (address.country) parts.push(address.country);
    return parts.length ? parts.join(', ') : 'Adresse nicht hinterlegt';
  }
}

export default new ShopService();
